import Lottie from 'lottie-react';
import coffeSteamAnimation from 'lottie/coffe-steam.json';

import { LayoutContainer } from 'layout';
import { Button, ButtonSize, InvertedBackground, SectionContainer } from 'ui';
import { contentWrapper, animationWrapper, sectionContainer } from './save-time-section.module.scss';
import { colorBgInvertedPrimaryOne } from 'ui/invertedBackground/inverted-background.module.scss';

export const SaveTimeSection = () => {
    return (
        <InvertedBackground color={colorBgInvertedPrimaryOne}>
            <LayoutContainer>
                <SectionContainer className={sectionContainer}>
                    <div className={contentWrapper}>
                        <h3>Save time and boost your productivity</h3>
                        <p>
                            You&apos;re busy, and so are we. That&apos;s why we created Elumity. With Elumity, you bring
                            a new order to your knowledge. Stay on top of your research and boost your productivity.
                            Silence the noise and focus on the signal.
                        </p>
                        <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                            <Button text="Try it now" size={ButtonSize.Medium} />
                        </a>
                    </div>
                    <div className={animationWrapper}>
                        <Lottie animationData={coffeSteamAnimation} loop={true} />
                    </div>
                </SectionContainer>
            </LayoutContainer>
        </InvertedBackground>
    );
};
